import ObjectJson from './object.json.js'
import { merge } from 'lodash'

export default class ObjectJsonObject extends ObjectJson {
  merge (repository, resource, { payload }) {
    repository.update(resource.path, merge(repository.get(resource.path), payload))
  }
}